import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

/** « Mettre à jour le passager » : la correction de la fiche ne touche pas les billets déjà émis (identité figée). */
export default function PassengerUpdateNotice() {
  const { t } = useTranslation();
  return <Alert type="info" showIcon className="mb-2" data-testid="passenger-update-notice" message={t('passenger_UpdateAppliesToNextTrips')} />;
}
